<div class="print-container">
    <h1 class="page-label text-center">
        Data Mapping – CSV Upload
    </h1>
</div>

<div class="tab-pane">

    <div class="print-container">
        <div class="row">
            <div class="col-sm-3 text-right">
                <label class="input-label">Data Mapping Set:</label>
            </div>
            <div class="col-sm-6">
                <select class="form-control" [(ngModel)]="selectedHeaderId" [disabled]="isUploading">
                    <option [ngValue]="undefined">-- Select --</option>
                    <option *ngFor="let h of headers" [ngValue]="h.id">
                        {{ h.mappingName }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <br>

    <div class="print-container">
        <div class="row">
            <div class="col-sm-3 text-right">
                <label class="input-label">CSV File:</label>
            </div>
            <div class="col-sm-6">
                <input type="file" class="form-control" accept=".csv" (change)="onFileSelected($event)">
            </div>
        </div>
    </div>

</div>
<br>
<div class="print-container">
    <div class="row text-center">
        <button class="btn btn-primary" [disabled]="isUploading || !selectedFile || !selectedHeaderId"
            (click)="upload()">
            Upload
        </button>
    </div>
</div>

<!-- ================= STATUS / PROGRESS ================= -->
<br>
<div class="print-container text-center">

    <div *ngIf="isUploading">
        <i class="fa fa-spinner fa-spin"></i>
        <span class="ml-2">Upload in progress...</span>
    </div>

    <div *ngIf="jobStatus">
        <p><strong>Status:</strong> {{ jobStatus.status }}</p>
        <p><strong>Processed:</strong> {{ jobStatus.processed }}</p>
        <p><strong>Failed:</strong> {{ jobStatus.failed }}</p>

        <p class="text-danger" *ngIf="jobStatus.message">
            {{ jobStatus.message }}
        </p>
    </div>

</div>